<template>
    <div>

        <div>
            <navigation/>


            <blog-list :searchQuery="searchQuery" headline="Search Results"/>

        </div>


    </div>
</template>

<script>

    import Navigation from '../layout/MainNavigation.vue';
    import BlogList from './BlogList.vue';

    export default {
        name: 'SearchPage',
        data() {
            return {
                searchQuery:''
            }
        },
        mounted(){
            if(this.$route.params.query){
                this.searchQuery = this.$route.params.query;
            }
        },
        beforeRouteUpdate(to, from, next) {
            this.searchQuery = to.params.query;
            next();
        },
        methods: {},
        components: {
            Navigation,
            BlogList
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/blogs/SearchPage.vue